import { render, staticRenderFns } from "./pickup-order.vue?vue&type=template&id=1c7e5e39&scoped=true"
import script from "./pickup-order.vue?vue&type=script&lang=js"
export * from "./pickup-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7e5e39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7e5e39')) {
      api.createRecord('1c7e5e39', component.options)
    } else {
      api.reload('1c7e5e39', component.options)
    }
    module.hot.accept("./pickup-order.vue?vue&type=template&id=1c7e5e39&scoped=true", function () {
      api.rerender('1c7e5e39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/user/components/pickup-order.vue"
export default component.exports